export const generateEmptyArrays = (count: number) => {
    const emptyArrays = Array.from({ length: count }, () => []);
    return emptyArrays;
};
